// Polyfill startsWith for IE11
if (!String.prototype.startsWith) {
  String.prototype.startsWith = function(searchString, position) {
    position = position || 0
    return this.substr(position, searchString.length) === searchString
  }
}

// Add polyfill for IE11, needed for SVG icons
if (
  !('classList' in document.createElementNS('http://www.w3.org/2000/svg', 'g'))
) {
  const descr = Object.getOwnPropertyDescriptor(
    HTMLElement.prototype,
    'classList'
  )
  Object.defineProperty(SVGElement.prototype, 'classList', descr)
}



// WEBPACK FOOTER //
// ./src/utils/polyfill.js